import { useEffect, useRef } from "react";

/** Like useEffect, but logs which dependencies changed.
 */
export function useLoggedEffect(
  description: string,
  effect: React.EffectCallback,
  deps: unknown[],
) {
  const prevDeps = useRef<unknown[]>();
  useEffect(() => {
    if (prevDeps.current) {
      const changed: string[] = [];
      for (let i = 0; i < deps.length; i++) {
        const current = deps[i];
        const previous = prevDeps.current[i];
        if (current !== previous) {
          changed.push(`dep at index ${i} from ${previous} to ${current}`);
        }
      }
      if (changed.length) {
        console.log('useLoggedEffect deps for ' + description + ' changed:', changed);
      }
    }
    prevDeps.current = deps;
    return effect();
  }, deps);
}
